import React, { ReactElement } from 'react';
import AntIcon, {
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  PhoneOutlined,
  CameraOutlined,
  UploadOutlined,
  VideoCameraOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileImageOutlined,
  FileTextOutlined,
  FileGifOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  UserOutlined,
  IdcardOutlined,
  HomeOutlined,
  FilterOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  PaperClipOutlined,
  EditOutlined,
  ReconciliationOutlined,
  StarOutlined,
  ThunderboltOutlined,
  PictureOutlined,
  FileAddOutlined,
  DesktopOutlined,
  ClockCircleOutlined,
  HistoryOutlined,
} from '@ant-design/icons';

import { ReactComponent as IconPuppy } from 'assets/icons/icon-puppy.svg';
import { ReactComponent as IconSire } from 'assets/icons/icon-parent-sire.svg';
import { ReactComponent as IconDam } from 'assets/icons/icon-parent-dam.svg';
import { ReactComponent as IconLitter } from 'assets/icons/icon-litter.svg';

interface IconProps {
  name: string;
  className?: string;
}

interface IconTypeProps {
  [key: string]: ReactElement;
}

export function Icon(props: IconProps): ReactElement {
  const { name, className } = props;

  const iconList: IconTypeProps = {
    get_listings: <ThunderboltOutlined className={className} />,
    photos: <PictureOutlined className={className} />,
    videos: <VideoCameraOutlined className={className} />,
    edits: <EditOutlined className={className} />,
    new_listings: <FileAddOutlined className={className} />,
    selection_screen: <DesktopOutlined className={className} />,
    pending_breeder: <PaperClipOutlined className={className} />,
    my_assignments: <HomeOutlined className={className} />,
    quick_filter: <FilterOutlined className={className} />,
    pending_breeder_menu: <ClockCircleOutlined className={className} />,
    listings_available: <EyeOutlined className={className} />,
    listings_unavailable: <EyeInvisibleOutlined className={className} />,
    history: <HistoryOutlined className={className} />,
    home: <HomeOutlined className={className} />,
    filter: <FilterOutlined className={className} />,
    available: <EyeOutlined className={className} />,
    unavailable: <EyeInvisibleOutlined className={className} />,
    pendingBreeder: <PaperClipOutlined className={className} />,
    puppy: <AntIcon component={IconPuppy} />,
    sire: <AntIcon component={IconSire} className={className} />,
    dam: <AntIcon component={IconDam} className={className} />,
    litter: <AntIcon component={IconLitter} />,
    spinner: <LoadingOutlined spin className={className} data-testid={name} />,
    warning: <ExclamationCircleOutlined className={className} />,
    success: <CheckCircleOutlined className={className} />,
    phone: <PhoneOutlined className={className} />,
    photo: <CameraOutlined className={className} />,
    video: <VideoCameraOutlined className={className} />,
    upload: <UploadOutlined className={className} />,
    media: <UploadOutlined className={className} />,
    file: <FileOutlined className={className} />,
    filePdf: <FilePdfOutlined className={className} />,
    fileImg: <FileImageOutlined className={className} />,
    filePng: <FileImageOutlined className={className} />,
    fileText: <FileTextOutlined className={className} />,
    fileGif: <FileGifOutlined className={className} />,
    fileWord: <FileWordOutlined className={className} />,
    fileExcel: <FileExcelOutlined className={className} />,
    userOutlined: <UserOutlined className={className} />,
    idcardOutlined: <IdcardOutlined className={className} />,
    workCard_photos: <CameraOutlined className={className} />,
    workCard_photo: <CameraOutlined className={className} />,
    workCard_videos: <VideoCameraOutlined className={className} />,
    workCard_video: <VideoCameraOutlined className={className} />,
    workCard_text: <EditOutlined className={className} />,
    workCard_multiple: <ReconciliationOutlined className={className} />,
    workCard_new_listings: <StarOutlined className={className} />,
    workCard_new: <StarOutlined className={className} />,
  };
  return iconList[name] || <AntIcon component={IconPuppy} />;
}

export const setFileExtensionIcon = (mediaName: string | undefined) => {
  const mediaNameExtension = mediaName?.slice(
    mediaName.lastIndexOf('.') - 1 + 2
  );

  switch (mediaNameExtension) {
    case 'pdf':
      return 'filePdf';
    case 'jpg':
    case 'jpeg':
    case 'png':
      return 'fileImg';
    case 'gif':
      return 'fileGif';
    case 'xls':
    case 'xlsx':
      return 'fileExcel';
    case 'docx':
    case 'doc':
      return 'fileWord';
    default:
      return 'fileText';
  }
};
